export default __webpack_public_path__ + "static/media/multiarrow.35cd1f62.svg";